import { render, staticRenderFns } from "./ProductGalleryManageNewItemFileDrop.vue?vue&type=template&id=4ab5eab6&scoped=true&"
import script from "./ProductGalleryManageNewItemFileDrop.vue?vue&type=script&lang=js&"
export * from "./ProductGalleryManageNewItemFileDrop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab5eab6",
  null
  
)

export default component.exports